import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GridLoading from '../../../../../components/grid-loading/';
import style from './style.module.less';

const InvoiceGridLoading = ({ shouldShowLeftNavWhenLoading }) => {
  return (
    <div
      className={classnames({
        [style['show-left-nav']]: shouldShowLeftNavWhenLoading,
      })}
    >
      <GridLoading />
    </div>
  );
};

InvoiceGridLoading.propTypes = {
  shouldShowLeftNavWhenLoading: PropTypes.bool.isRequired,
};

export default InvoiceGridLoading;
